<ngx-spinner bdColor="rgba(20,20,20,0.45)" size="medium" color="$1ab394" loadingText=""
type="ball-scale-multiple">
    <div id="preloader">
        <div class="loader"></div>
    </div>
</ngx-spinner>
